import { getCanAddToCart, getCustomerServiceNumber, getIsNavinkPlug, isInternalBrand } from '../../selectors';
import { getHostVendorDict, getVendorDict } from '../../logics';

import CopyRight from '../CopyRight';
import Logo from '../Logo';
import React from 'react';
import ServiceNumber from './../ServiceNumber';
import styles from './Error.scss';
import { useSelector } from 'react-redux';

const Error = () => {
  const isAplInternalBrand = useSelector(isInternalBrand);
  const isNavInk = useSelector(getIsNavinkPlug);
  const canAddToCart = useSelector(getCanAddToCart);
  const companyName = getVendorDict('companyName') || getHostVendorDict('companyName');
  const serviceNumber =
    useSelector(getCustomerServiceNumber) || getVendorDict('csNumber') || getHostVendorDict('csNumber');
  return (
    <div className={styles['main-error']}>
      <div className={styles['error-container-500']}>
        {isAplInternalBrand && !isNavInk && (
          <>
            <div className={styles['logo-container-500']}>
              <Logo companyName={companyName} dark />
            </div>
            <div className={styles['logo-text-500']}>Your Trusted Leader in Promotional Products</div>
          </>
        )}
        <span className={styles['error-text-500']}>
          We're Sorry. We are temporarily experiencing an internal server problem.
        </span>
        <ul>
          <li className={styles['error-list-500']}>
            <span className={styles['bullet-500']}>• </span>
            <span className={styles['list-text-500']}>Please try refreshing your page</span>
          </li>
          {canAddToCart && serviceNumber && serviceNumber.length > 0 && (
            <li className={styles['error-list-500']}>
              <span className={styles['bullet-500']}>• </span>
              <span className={styles['list-text-500']}>Contact our Customer Service Team at </span>
              <ServiceNumber />
            </li>
          )}
        </ul>

        {canAddToCart && (
          <div className={styles['number-container-500']}>
            <ServiceNumber />
          </div>
        )}
      </div>
      {companyName && companyName.length > 0 && (
        <div className={styles['copyright-notice-500']}>
          <CopyRight />
          {` ${companyName}`}
        </div>
      )}
    </div>
  );
};
export default Error;
